/**
 * Default policy type stamped on an appointment / eligibility-check record when
 * the source doesn't specify one. Shared because both domains use it:
 * appointmentPull's CSV + Revolution ingest and eligibilityCheck's check/identity
 * flow. Lives in `shared/` (not a feature) so neither domain has to import the
 * other's barrel for it.
 */
export const DEFAULT_POLICY_TYPE = "Medical";

/**
 * The other policy type. A coverage is Vision when its payer routes to an RPA
 * vision vendor (VSP / EyeMed) and Medical otherwise — see
 * `src/utils/payerRouting.ts` `coverageTypeForPayer`.
 *
 * Not merely cosmetic: policy type is part of the appointment identity hash, so
 * it is what keeps one patient's vision and medical coverages in two separate
 * appointment docs when neither carries a member ID.
 */
export const VISION_POLICY_TYPE = "Vision";
